// Art Exhibits Grid — AJAX filter by Exhibit Category taxonomy.
// Imported from js/global.js. No-op when the block isn't on the page.

export default function initArtExhibitsGrid() {
  const block = document.querySelector(".aviatrix-block--art-exhibits-grid");
  if (!block || typeof artExhibits === "undefined") return;

  const results = block.querySelector(".art-exhibits-grid__results");
  const filterBtns = block.querySelectorAll(".art-exhibits-grid__filter");
  if (!results) return;

  const exclude = results.getAttribute("data-exclude") || "0";
  let isLoading = false;
  let activeTerm = "";

  function setActive(term) {
    filterBtns.forEach((btn) => {
      const isActive = (btn.getAttribute("data-term") || "") === term;
      btn.classList.toggle("is-active", isActive);
      btn.setAttribute("aria-pressed", isActive ? "true" : "false");
    });
  }

  async function fetchResults(term) {
    if (isLoading) return;
    isLoading = true;
    results.setAttribute("aria-busy", "true");

    try {
      const response = await fetch(artExhibits.ajaxurl, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({
          action: "filter_art_exhibits",
          nonce: artExhibits.nonce,
          category: term || "",
          exclude: exclude,
        }),
      });
      const data = await response.json();

      if (data && data.success) {
        results.innerHTML = data.data.html;
        // The fade-in observer only runs at load, so AJAX-injected cards would
        // stay at opacity 0 — reveal them immediately.
        results
          .querySelectorAll(".js-fadein, .js-fadein-up")
          .forEach((el) => el.classList.add("is-visible"));
        activeTerm = term;
        setActive(term);
      } else {
        results.innerHTML =
          '<p class="art-exhibits-grid__no-results">Something went wrong loading exhibits. Please try again.</p>';
      }
    } catch (err) {
      results.innerHTML =
        '<p class="art-exhibits-grid__no-results">Something went wrong loading exhibits. Please try again.</p>';
    } finally {
      results.setAttribute("aria-busy", "false");
      isLoading = false;
    }
  }

  filterBtns.forEach((btn) => {
    btn.addEventListener("click", () => {
      const term = btn.getAttribute("data-term") || "";
      if (term === activeTerm) return;
      fetchResults(term);
    });
  });
}
